<cm-icon-button icon="copy" (cmPress)="click()"></cm-icon-button>
